import {
  TransactionAiInsights,
  TransactionAiInsightType,
} from 'src/models/transaction.models'

export const hasDisplayablePolicyAgentInsight = (
  insights: TransactionAiInsights[] | undefined,
): boolean =>
  Boolean(
    insights?.some(
      (insight) =>
        insight.insightType === TransactionAiInsightType.PolicyAgent &&
        Boolean(insight.insightText),
    ),
  )
